"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportEditSuccess = exports.reportEditSaveReport = exports.reportEditReset = exports.reportEditGotoUpdate = exports.reportEditGetPage = exports.reportEditError = exports.reportEditChangeBrand = void 0;
var _reportEdit = require("./reportEdit.constant");
// @flow

// common success
var reportEditSuccess = function reportEditSuccess(actionType, data) {
  return {
    type: _reportEdit.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportEditSuccess = reportEditSuccess;
var reportEditError = function reportEditError(actionType, error) {
  return {
    type: _reportEdit.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * save edit
 * @param payload
 * @returns api response
 * @description this function used to save edit.
 */
exports.reportEditError = reportEditError;
var reportEditSaveReport = function reportEditSaveReport(payload) {
  return {
    type: _reportEdit.actionTypes.SAVE_REPORT,
    payload: payload
  };
};

/**
 * save edit
 * @param payload
 * @returns api response
 * @description this function used to save edit.
 */
exports.reportEditSaveReport = reportEditSaveReport;
var reportEditGotoUpdate = function reportEditGotoUpdate(payload) {
  return {
    type: _reportEdit.actionTypes.GOTO_UPDATE,
    payload: payload
  };
};

/**
 * get page
 * @param payload
 * @returns api response
 * @description this function used to get page.
 */
exports.reportEditGotoUpdate = reportEditGotoUpdate;
var reportEditGetPage = function reportEditGetPage(payload) {
  return {
    type: _reportEdit.actionTypes.GET_PAGE,
    payload: payload
  };
};

/**
 * change brand
 * @param payload
 * @returns api response
 * @description this function used to change brand.
 */
exports.reportEditGetPage = reportEditGetPage;
var reportEditChangeBrand = function reportEditChangeBrand(payload) {
  return {
    type: _reportEdit.actionTypes.CHANGE_BRAND,
    payload: payload
  };
};

/**
 * reser
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.reportEditChangeBrand = reportEditChangeBrand;
var reportEditReset = function reportEditReset(payload) {
  return {
    type: _reportEdit.actionTypes.RESET,
    payload: payload
  };
};
exports.reportEditReset = reportEditReset;